export default __webpack_public_path__ + "assets/courier-overview-video-3-thumbnail-new.png";